
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
name: 'set-age',
components: {
Popup,
Flexbox,
FlexboxItem,
},
props: {
isShow: {
type: Boolean,
default: false,
},
defaultAge: {
type: Number | String,
default: 0,
},
},
watch: {
isShow(cur){
this.popupShow = cur;
},

defaultAge(cur){
this.currentAge = Number(cur) + 1;
},
},
data(){
return {
popupShow: false,
currentAge: 1,
};
},
methods: {
onHidePopup(){
this.$emit('on-close');
},

onSelectAge(age){
this.currentAge = age;
this.onHidePopup();
this.$emit('get-age', age);
},
}
}



// WEBPACK FOOTER //
// ./src/views/check-in-number/components/SetAge.vue